import { useState } from "react";
import { specials } from "@/mocks/home";

export default function Specials() {
  const [saved, setSaved] = useState<Record<string, boolean>>({});
  const [likes, setLikes] = useState<Record<string, number>>({ s1: 308, s2: 521, s3: 196 });

  const toggleSave = (id: string) =>
    setSaved((p) => ({ ...p, [id]: !p[id] }));

  const like = (id: string) =>
    setLikes((p) => ({ ...p, [id]: (p[id] || 0) + 1 }));

  return (
    <section id="deep" className="scroll-mt-24 bg-[#faf5ee]">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="flex items-end justify-between gap-4 mb-6 flex-wrap">
          <div>
            <div className="text-xs font-semibold tracking-widest text-[#c2410c] mb-2 flex items-center gap-2">
              <i className="ri-quill-pen-line"></i> IN-DEPTH
            </div>
            <h2 className="font-display text-2xl md:text-3xl font-bold text-[#241c15]">
              深度解析 · 看透门道
            </h2>
          </div>
          <p className="text-sm text-[#8a7760] hidden md:block">
            不满足于「发生了什么」，更关心「为什么会发生」
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
          {specials.map((s, i) => (
            <article
              key={s.id}
              className={`group bg-white border border-[#ead9c5] rounded-2xl overflow-hidden flex flex-col transition-colors hover:border-[#c9a576] cursor-pointer ${
                i === 0 ? "lg:col-span-2 lg:flex-row" : ""
              }`}
            >
              <div
                className={`overflow-hidden ${
                  i === 0 ? "lg:w-1/2 aspect-video lg:aspect-auto" : "aspect-[16/10]"
                }`}
              >
                <img
                  src={s.img}
                  alt={`${s.title} 深度专题封面配图`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className={`p-5 md:p-6 flex flex-col flex-1 ${i === 0 ? "lg:w-1/2" : ""}`}>
                <div className="flex items-center gap-2">
                  <span className="text-[11px] text-[#fff7ed] bg-[#c2410c] rounded-full px-2.5 py-1">
                    {s.cat}
                  </span>
                  <span className="text-[11px] text-[#9a8772] inline-flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {s.read}
                  </span>
                </div>
                <h3 className="font-display text-lg md:text-[20px] leading-snug font-bold text-[#241c15] mt-3 group-hover:text-[#c2410c] transition-colors">
                  {s.title}
                </h3>
                <p className={`text-[14px] leading-7 text-[#7a6a58] mt-2 ${i === 0 ? "md:line-clamp-3" : "line-clamp-3"}`}>
                  {s.desc}
                </p>
                <div className="flex items-center gap-4 mt-4 pt-3 border-t border-[#f0e5d6] text-[12px] text-[#8a7760]">
                  <button
                    onClick={() => like(s.id)}
                    className="inline-flex items-center gap-1.5 hover:text-[#c2410c] transition-colors cursor-pointer"
                    aria-label="点赞"
                  >
                    <i className="ri-thumb-up-line text-[15px]"></i>
                    {likes[s.id] || 0} 有帮助
                  </button>
                  <button
                    onClick={() => toggleSave(s.id)}
                    className={`inline-flex items-center gap-1.5 transition-colors cursor-pointer ${
                      saved[s.id] ? "text-[#c2410c]" : "hover:text-[#c2410c]"
                    }`}
                    aria-label="收藏"
                  >
                    <i className={saved[s.id] ? "ri-bookmark-fill text-[15px]" : "ri-bookmark-line text-[15px]"}></i>
                    {saved[s.id] ? "已收藏" : "收藏"}
                  </button>
                  <span className="ml-auto inline-flex items-center gap-1">
                    <i className="ri-chat-3-line"></i>
                    {s.count}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}